<template>
  <div class="container page">
    <getting-started class="pt-5" />

    <div class="row pt-5">
      <div class="col-xs-12 col-md-6 flex-grow">
        <b-card class="h-100">
          <b-card-title>Iframe einbinden</b-card-title>

          <b-card-text>
            Binden Sie Ihre Fahrzeuge wie folgt in Ihre Website ein. Das Aussehen können Sie Ihrer eigenen Website anpassen.
          </b-card-text>
          <div class="text-center">
            <b-alert
              show
              variant="warning"
            >
              <code>&lt;iframe src="https://my.carlisting.de/{{currentUser.domain}}/vehicle/list">&lt;/iframe></code>
            </b-alert>

          </div>
        </b-card>
      </div>

      <div class="col-xs-12 col-md-6">
        <b-card class="h-100">
          <div
            v-if="!$store.getters['auth/hasStripe']"
            class="payment-wall d-flex flex-column justify-content-center text-center px-3"
          >
            <b-icon
              icon="alert-octagon"
              class="align-self-center"
              font-scale="3.5"
            ></b-icon>
            <div class="w-100">Die Domainverknüpfung ist nur mit einem Abonnement möglich.</div>
          </div>

          <b-card-title>Mit Ihrer Domain verknüpfen</b-card-title>
          <template v-if="currentUser.isOwnDomainSetUp === false">
            <b-card-text>
              Ihre Domain wird mit dem Server verknüpft. Dies kann bis zu 48 Stunden dauern. Sie werden per Mail über den
              Fortschritt informiert.
            </b-card-text>
            <!-- <div class="row align-items-center justify-content-center">
              <b-icon
                icon="hammer"
                font-scale="2"
              ></b-icon>
              <div class="text-muted">in progress</div>
            </div> -->
          </template>
          <template v-if="currentUser.isOwnDomainSetUp === null">
            <b-card-text>
              Binden Sie Ihre Fahrzeugliste wie folgt in Ihre Website ein. Sie können die Fahrzeugliste
              Ihrem Aussehen anpassen.
            </b-card-text>

            <b-button
              @click="showDomainModal = true"
              variant="primary"
            >Domain verknüpfen</b-button>
          </template>
          <template v-if="currentUser.isOwnDomainSetUp === true">
            <b-card-text>
              <b-icon
                variant="success"
                icon="check-circle"
                font-scale="1.5"
              />mit {{currentUser.ownDomain}} verknüpft
            </b-card-text>

          </template>
        </b-card>
      </div>
    </div>

    <welcome-modal v-model="showWelcomeModal" />
    <domain-modal v-model="showDomainModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import WelcomeModal from '@/components/WelcomeModal.vue';
import DomainModal from '@/components/DomainModal.vue';
import GettingStarted from '@/components/GettingStarted.vue';

export default {
  name: 'HomeDashboard',
  data: () => ({
    showWelcomeModal: false,
    showDomainModal: false,
  }),
  components: {
    WelcomeModal,
    GettingStarted,
    DomainModal,
  },

  computed: {
    ...mapState('auth', ['currentUser']),
  },

  mounted () {
    this.showWelcomeModal = !this.currentUser.mobileDeId && !this.currentUser.as24Id;
  }
}
</script>

<style scoped>
</style>
